import { render, staticRenderFns } from "./InputQuestion.vue?vue&type=template&id=08554b65&scoped=true&"
import script from "./InputQuestion.vue?vue&type=script&lang=js&"
export * from "./InputQuestion.vue?vue&type=script&lang=js&"
import style0 from "./InputQuestion.vue?vue&type=style&index=0&id=08554b65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08554b65",
  null
  
)

export default component.exports